'use strict';

export { default as LocalStorageService } from './localStorage.service';
